module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare-e86f2b4438d3a8e23d11ab3207544259.png";